import axios from "axios";
import { nordNxtApiEndpoint } from "../../config/config";

export default async function getAllDcaAssets() {
  const { data } = await axios.get(
    `${nordNxtApiEndpoint}/product/get-all-dca-assets`,
  );
  return data;
}
